import React, { createContext, useContext, useState } from 'react';

const DayPassContext = createContext();

export function useDayPassContext() {
  return useContext(DayPassContext);
}

export function DayPassContextProvider({ children }) {
  const [dataToSend, setDataToSend] = useState(null);
  const [additionalData, setAdditionalData] = useState(null);

  const setDayPassData = (data) => {
    setDataToSend(data);
  };

  // Function to set the additional data
  const setAdditionalDataFn = (data) => {
    setAdditionalData(data);
  };

  console.log("data send", dataToSend);

  return (
    <DayPassContext.Provider value={{ dataToSend, setDayPassData, additionalData, setAdditionalData: setAdditionalDataFn }}>
      {children}
    </DayPassContext.Provider>
  );
}
